import _get from "lodash/get";
import _capitalize from "lodash/capitalize";
import "core-js/modules/es6.array.map.js";

/**
 * @module
 *
 * @description Mortgage utils
 */
import { MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS } from '../../constants';
import { getFeaturedLoanAttributes, getNationalOrRegional } from '../../selectors/mortgages';
/**
 * Gather readable representations of loan types and products.
 *
 * @param {Object} marketplaceEntity - The marketplace entity
 * @return {Array} - The array of loan type & product labels
 */

export var getLoanTypeAndProductLabels = function getLoanTypeAndProductLabels(marketplaceEntity) {
  var featuredLoanAttributes = getFeaturedLoanAttributes(marketplaceEntity);
  return (featuredLoanAttributes === null || featuredLoanAttributes === void 0 ? void 0 : featuredLoanAttributes.map(function (attr) {
    return MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS[attr];
  })) || [];
};
/**
 * Get readable representation of coverage area.
 * @param {Object} marketplaceEntity - The marketplace entity
 * @return {String} - The coverage area label.
 */

export var getCoverageAreaLabel = function getCoverageAreaLabel(marketplaceEntity) {
  var coverageArea = getNationalOrRegional(marketplaceEntity);
  return coverageArea && _capitalize(coverageArea);
};
/**
 * Is the entity from Homeownership or Marketplace?
 * @deprecated
 *
 * @param {Object} entity - The Mortgages entity (from Homeownership or Marketplace).
 * @return {Boolean} - Whether the entity is from Homeownership service?
 */

export var isLegacyHomeownershipEntity = function isLegacyHomeownershipEntity(entity) {
  return _get(entity, 'type') === 'nw_lender';
};